import * as React from 'react';
import { Component, deps, inject, observer } from '../lib/component';
import { AccountLayout } from '../components/account/layout';
import { Loading } from '../components/loading/loading';
import { centerCenter } from 'csstips';
import { px } from 'csx';
import { style } from 'typestyle';
import {PageAccountInvites} from '../components/page-account-invites';
import UserCoupon from '../components/user/coupon';
import {colorSubtle} from '../theme/color';

export interface AccountCouponsPageProps {

}

@inject(deps) @observer
export class AccountCouponsPage extends Component<AccountCouponsPageProps> {
  render() {
    if (this.props.model.ui.isServer) return <div />;

    const model = this.props.model.page.accountCoupons;

    if (model.loading) return (
      <AccountLayout>
        <div className={style({ padding: px(80), ...centerCenter })}>
          <Loading />
        </div>
      </AccountLayout>
    );

    return (
      <AccountLayout>
        {!model.coupons.length && (
          <div className={AccountCouponsPage.styles.empty}>
            You don't have any coupons at this time.
          </div>
        )}
        {!!model.coupons.length && (
          <div className={PageAccountInvites.styles.coupons}>
            {model.coupons.map((coupon, index) => (
              <UserCoupon key={index} coupon={coupon}/>
            ))}
          </div>
        )}
      </AccountLayout>
    )
  }

  static styles = {
    empty: style({
      ...centerCenter,
      height: px(120),
      fontWeight: 200,
      fontSize: px(18),
      color: colorSubtle.toString()
    }),
  }
}